// extracted by mini-css-extract-plugin
export default {"companyContainer":"AN-z","companyImage":"BN-z","container":"CN-z","heading":"DN-z","darkText":"EN-z","smallHeading":"FN-z","darkBackground":"GN-z","whiteBackground":"HN-z"};